import Config from "../Config";

import { Fragment, useEffect, useRef, useState } from "react";

import imgUser  from "../user.png"
import imgChange  from "../change.png"
import imgExit  from "../exit.png"
import imgMenu  from "../menu.png"

function MenuTop(props)
{

        const [listDialog, setListDialog] = useState(0);



        const changeView = () =>
        {
            if(listDialog == 0)
            {
                setListDialog(1);
            }else setListDialog(0);
        }


        const selectSell = (e) => {

            var id = e.target.getAttribute("atr-id");

            //if(Config.env == 'dev') console.log("MenuTop-selectSell: " + id);

            setListDialog(0);
            props.mainView.changeProfile(id);       
        }




        var sell = "";       
        if(props.userData != undefined)
        {
            for(var k=0; k < props.userData.sells.length; k++ )
            {                
                if(props.userData.sells[k].id == props.userData.fak_sprzedawcy_id)
                {
                    sell = props.userData.sells[k].nip + ", " +  props.userData.sells[k].nazwa;
                    break;
                }
            }
        }



        var listFim = <div className="dlg_window shadowx">
            <div className="dlg_title">Wybierz podmiot</div>
            <div className="dlg_msg">
                
                   {
                        props.userData.sells.map( (item, ix) => {
                                return <div  key={ix+1} className="item_sell" atr-id={item.id} onClick={selectSell} >{item.nazwa}</div>
                        } )
                   } 
 

            </div>
            <div className="dlg_btn">
                    <span className="btn" onClick={changeView}>anuluj</span>
            </div>
        </div>

        if(listDialog == 0) listFim = null;


       


        return <div className="menu_top">

                    <div className="companyName">
                      

                        <span className="menu_top_img">                           

                             <img src={imgMenu} onClick={props.mainView.changeMenuStatus} />   
                             
                             &nbsp;  
                             &nbsp;  

                             <span onClick={changeView}>
                                <img src={imgChange} />            
                                &nbsp;  
                                {sell}     
                             </span>                                                    

                        </span>                                                                  
                    </div>

                    <div className="menu_short">
                         

                           <span className="menu_top_img" onClick={props.logout}>Wyloguj [q] <img src={imgExit} /> </span>
                    </div>

                    {listFim}
        </div>
}



export default MenuTop;